export default "__VITE_ASSET__DW5JqIt3__";